const DAY_MS = 24 * 60 * 60 * 1000;

/**
 * "2 weeks ago" for the Previous SOAP notes accordion. Whole units only —
 * the exact date sits next to it, so precision here would be noise.
 */
export function relativeTimeLabel(value: string, now: string): string {
  const elapsedMs = Date.parse(now) - Date.parse(value);
  if (!Number.isFinite(elapsedMs)) return "";
  const days = Math.floor(elapsedMs / DAY_MS);
  if (days < 1) return "today";
  if (days === 1) return "yesterday";
  if (days < 7) return `${days} days ago`;
  const weeks = Math.floor(days / 7);
  if (weeks < 9) return weeks === 1 ? "1 week ago" : `${weeks} weeks ago`;
  const months = Math.floor(days / 30);
  if (months < 12) return months <= 1 ? "1 month ago" : `${months} months ago`;
  const years = Math.floor(days / 365);
  return years <= 1 ? "1 year ago" : `${years} years ago`;
}
